import axios from 'axios'
import store from '@/store'
import router from '@/router'

axios.defaults.timeout = 5000
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
// axios.defaults.baseURL = 'https://api.onlinegit.com/v1/'
// axios.defaults.baseURL = 'https://testapi.onlinegit.com/v1/'
// axios.defaults.withCredentials = true // 发送 cookie

/**
 * http request 请求 拦截器
 */
axios.interceptors.request.use(
  config => {
    if (window.localStorage.getItem('token')) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers = {
        'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
        // 'Content-Type': 'multipart/form-data',
      }
    }
    return config
  }, err => {
    return Promise.reject(err)
  }
)

/**
 * http response 响应 拦截器
 */
axios.interceptors.response.use(
  response => {
    if (response.data && response.data.status === 401) { // 401, token失效
      // store.commit('logout')
      window.localStorage.removeItem('token')
      router.push({ name: 'signin' })
    }
    return response
  }, error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // store.commit('logout')
          window.localStorage.removeItem('token')
          router.push({ name: 'signin' })
      }
    }
    return Promise.reject(error.response.data)
  }
)

// https://gitee.com/renrenio/renren-fast-vue/blob/master/src/utils/httpRequest.js
// https://github.com/superman66/vue-axios-github/blob/master/src/http.js

// https://www.jb51.net/article/149537.htm
export default axios
